module.exports = __webpack_public_path__ + "media/Pika-2.e99d83ee.mp4";